import blankComponent from "../App.vue";

// Auth routes
import P404 from "../views/auth/404.vue";
import P401 from "../views/auth/401.vue";
import Login from "../views/auth/Login.vue";
import AuthBase from "../views/auth/Index.vue";
import PrintLayout from "@/components/PrintLayout.vue";
import PrintBill from "@/components/common/printBill.vue";
import PasswordReset from "../views/auth/passwordReset.vue";
import PrintTable from "@/components/common/printTable.vue";
import printDashboard from "@/components/common/printDashboard.vue";

// Dashboard routes
import lctr from "../views/reports/LCTR.vue";
import nonLCTR from "../views/reports/nonLCTR.vue";
import exchangeIncomeReport from "../views/reports/exchangeIncomeReport.vue";
import notifications from "../views/reports/notifications.vue";
import balancesheet from "../views/reports/balancesheet/index.vue";
import transactionsReport from "../views/reports/transactionsReport.vue";
import incomestatement from "../views/reports/incomestatement/index.vue";

import Index from "../views/dashboard/Index.vue";
import analytics from "../views/analytics/index.vue";
import reports from "../views/reports/companyReports.vue";
import rateIncomes from "../views/reports/rateIncomes.vue";

import banks from "../views/people/banks.vue";
import staffs from "../views/people/staffs.vue";
import expenses from "../views/people/expenses.vue";
import sarafs from "../views/people/sarafs/index.vue";
import commissions from "../views/people/commissions.vue";
import assets from "../views/people/assets/index.vue";
import liabilities from "../views/people/liabilities/index.vue";
import customers from "../views/people/customers.vue";
import branchs from "../views/people/branchs/index.vue";
import viewPerson from "../views/people/viewPerson.vue";
import shareholders from "../views/people/shareholders.vue";

import individuals from "../views/people/individuals/index.vue";
import newIndividuals from "../views/people/individuals/new.vue";
import viewIndividuals from "../views/people/individuals/view.vue";
import printIndividualCIF from "../views/people/individuals/printIndividualCIF";

import corporates from "../views/people/corporates/index.vue";
import newCorporates from "../views/people/corporates/new.vue";
import viewCorporates from "../views/people/corporates/view.vue";
import printCorporateCIF from "../views/people/corporates/printCorporateCIF";

import incomes from "../views/people/incomes.vue";
import branchAccounts from "../views/branchAccounts/branchAccounts.vue";

import blank from "../views/roznamcha/blank.vue";
import debits from "../views/roznamcha/tabs/debits.vue";
import roznamcha from "../views/roznamcha/roznamcha.vue";
import credits from "../views/roznamcha/tabs/credits.vue";
import exchanges from "../views/roznamcha/tabs/exchanges.vue";
import a2aTransfers from "../views/roznamcha/tabs/a2aTransfers.vue";
import sendTransfers from "../views/roznamcha/tabs/sendTransfers.vue";
import receiveTransfers from "../views/roznamcha/tabs/receiveTransfers.vue";

// user and roles
import roles from "../views/roles";
import users from "../views/users";
import newUser from "../views/users/NewUser";
import userView from "../views/users/userView";
import Profile from "../views/users/Profile.vue";
import backups from "../views/settings/backups.vue";
import currencies from "../views/settings/currencies.vue";

export default [
    {
        path: "/",
        component: Index,
        meta: { forAuth: true },
        children: [
            {
                path: "/",
                component: analytics,
                meta: { forAuth: true, can: "view_dashboard" }
            },
            {
                path: "/roznamcha",
                component: roznamcha,
                meta: { forAuth: true }
            },
            {
                component: blank,
                meta: { forAuth: true },
                path: "/daily-transactions",
                children: [
                    {
                        path: "credits",
                        component: credits,
                        meta: { forAuth: true, can: "all_credits" }
                    },
                    {
                        path: "debits",
                        component: debits,
                        meta: { forAuth: true, can: "all_debits" }
                    },
                    {
                        path: "exchanges",
                        component: exchanges,
                        meta: { forAuth: true, can: "all_exchanges" }
                    },
                    {
                        path: "a2a-transfers",
                        meta: { forAuth: true, can: "all_a2a_transfers" },
                        component: a2aTransfers
                    },
                    {
                        path: "send-transfers",
                        meta: { forAuth: true, can: "all_send_transfers" },
                        component: sendTransfers
                    },
                    {
                        meta: { forAuth: true, can: "all_receive_transfers" },
                        path: "receive-transfers",
                        component: receiveTransfers
                    }
                ]
            },

            {
                path: "/reports",
                meta: { forAuth: true },
                component: blankComponent,
                children: [
                    {
                        path: "/",
                        component: reports,
                        meta: { forAuth: true, can: "ledger_report" }
                    },
                    {
                        path: "/rate-incomes",
                        component: rateIncomes,
                        meta: { forAuth: true, can: "daily_profit" }
                    },
                    {
                        path: "/income-statement",
                        component: incomestatement,
                        meta: { forAuth: true, can: "lctr_report" }
                    },
                    {
                        path: "/balance-sheet",
                        component: balancesheet,
                        meta: { forAuth: true, can: "lctr_report" }
                    },
                    {
                        component: lctr,
                        path: "/lctr-report",
                        meta: { forAuth: true, can: "lctr_report" }
                    },
                    {
                        component: nonLCTR,
                        path: "/non-lctr-report",
                        meta: { forAuth: true, can: "lctr_report" }
                    },
                    {
                        path: "/exchange-incomes",
                        component: exchangeIncomeReport,
                        meta: { forAuth: true, can: "transactions_report" }
                    },
                    {
                        path: "/notifications",
                        component: notifications,
                        meta: { forAuth: true, can: "transactions_report" }
                    },
                    {
                        component: individuals,
                        path: "/individuals-kyc-report",
                        meta: { forAuth: true, can: "all_individuals" }
                    },
                    {
                        component: transactionsReport,
                        path: "/transactions-report",
                        meta: { forAuth: true, can: "transactions_report" }
                    },
                    {
                        component: corporates,
                        path: "/corporates-kyc-report",
                        meta: { forAuth: true, can: "all_corporates" }
                    }
                ]
            },
            {
                path: "/individuals",
                meta: { forAuth: true },
                component: blankComponent,
                children: [
                    {
                        path: "/",
                        component: individuals,
                        meta: { forAuth: true, can: "all_individuals" }
                    },
                    {
                        path: "new",
                        component: newIndividuals,
                        meta: { forAuth: true, can: "add_individuals" }
                    },
                    {
                        path: "edit/:id",
                        component: newIndividuals,
                        meta: { forAuth: true, can: "edit_individuals" }
                    },
                    {
                        path: ":id",
                        component: viewIndividuals,
                        meta: { forAuth: true, can: "view_individuals" }
                    }
                ]
            },
            {
                path: "/corporates",
                meta: { forAuth: true },
                component: blankComponent,
                children: [
                    {
                        path: "/",
                        component: corporates,
                        meta: { forAuth: true, can: "all_corporates" }
                    },
                    {
                        path: "new",
                        component: newCorporates,
                        meta: { forAuth: true, can: "add_corporates" }
                    },
                    {
                        path: "edit/:id",
                        component: newCorporates,
                        meta: { forAuth: true, can: "edit_corporates" }
                    },
                    {
                        path: ":id",
                        component: viewCorporates,
                        meta: { forAuth: true, can: "view_corporates" }
                    }
                ]
            },
            {
                path: "/customers",
                meta: { forAuth: true },
                component: blankComponent,
                children: [
                    {
                        path: "/",
                        component: customers,
                        meta: { forAuth: true, can: "all_customers" }
                    },
                    {
                        path: ":id",
                        component: viewPerson,
                        meta: { forAuth: true, can: "view_customers" }
                    }
                ]
            },
            {
                path: "/externals",
                meta: { forAuth: true },
                component: blankComponent,
                children: [
                    {
                        path: "/",
                        component: customers,
                        meta: { forAuth: true, can: "all_customers" }
                    },
                    {
                        path: ":id",
                        component: viewPerson,
                        meta: { forAuth: true, can: "view_customers" }
                    }
                ]
            },
            {
                path: "/staffs",
                meta: { forAuth: true },
                component: blankComponent,
                children: [
                    {
                        path: "/",
                        component: staffs,
                        meta: { forAuth: true, can: "all_customers" }
                    },
                    {
                        path: ":id",
                        component: viewPerson,
                        meta: { forAuth: true, can: "view_customers" }
                    }
                ]
            },
            {
                path: "/sarafs",
                meta: { forAuth: true },
                component: blankComponent,
                children: [
                    {
                        path: "/",
                        component: sarafs,
                        meta: { forAuth: true, can: "all_sarafs" }
                    },
                    {
                        path: ":id",
                        component: viewPerson,
                        meta: { forAuth: true, can: "view_sarafs" }
                    }
                ]
            },
            {
                path: "/commissions",
                meta: { forAuth: true },
                component: blankComponent,
                children: [
                    {
                        path: "/",
                        component: commissions,
                        meta: { forAuth: true, can: "all_commissions" }
                    },
                    {
                        path: ":id",
                        component: viewPerson,
                        meta: { forAuth: true, can: "view_commissions" }
                    }
                ]
            },
            {
                path: "/branchs",
                meta: { forAuth: true },
                component: blankComponent,
                children: [
                    {
                        path: "/",
                        component: branchs,
                        meta: { forAuth: true, can: "all_branchs" }
                    },
                    {
                        path: ":id",
                        component: viewPerson,
                        meta: { forAuth: true, can: "view_branchs" }
                    }
                ]
            },
            {
                path: "/assets",
                meta: { forAuth: true },
                component: blankComponent,
                children: [
                    {
                        path: "/",
                        component: assets,
                        meta: { forAuth: true, can: "all_assets" }
                    },
                    {
                        path: ":id",
                        component: viewPerson,
                        meta: { forAuth: true, can: "view_assets" }
                    }
                ]
            },
            {
                path: "/liabilities",
                meta: { forAuth: true },
                component: blankComponent,
                children: [
                    {
                        path: "/",
                        component: liabilities,
                        meta: { forAuth: true, can: "all_liabilities" }
                    },
                    {
                        path: ":id",
                        component: viewPerson,
                        meta: { forAuth: true, can: "view_liabilities" }
                    }
                ]
            },
            {
                path: "/expenses",
                meta: { forAuth: true },
                component: blankComponent,
                children: [
                    {
                        path: "/",
                        component: expenses,
                        meta: { forAuth: true, can: "all_expenses" }
                    },
                    {
                        path: ":id",
                        component: viewPerson,
                        meta: { forAuth: true, can: "view_expenses" }
                    }
                ]
            },
            {
                path: "/banks",
                meta: { forAuth: true },
                component: blankComponent,
                children: [
                    {
                        path: "/",
                        component: banks,
                        meta: { forAuth: true, can: "all_banks" }
                    },
                    {
                        path: ":id",
                        component: viewPerson,
                        meta: { forAuth: true, can: "view_banks" }
                    }
                ]
            },
            {
                path: "/shareholders",
                meta: { forAuth: true },
                component: blankComponent,
                children: [
                    {
                        path: "/",
                        component: shareholders,
                        meta: { forAuth: true, can: "all_shareholders" }
                    },
                    {
                        path: ":id",
                        component: viewPerson,
                        meta: { forAuth: true, can: "view_shareholders" }
                    }
                ]
            },
            {
                path: "/incomes",
                component: blankComponent,
                meta: { forAuth: true, can: "view_profits" },
                children: [
                    {
                        path: "/",
                        component: incomes,
                        meta: { forAuth: true, can: "all_incomes" }
                    },
                    {
                        path: ":id",
                        component: viewPerson,
                        meta: { forAuth: true, can: "view_incomes" }
                    }
                ]
            },
            {
                path: "/branch-accounts",
                component: branchAccounts,
                meta: { forAuth: true, can: "view_cash_accounts" }
            },
            // {
            //     path: "/stock",
            //     component: stock,
            //     meta: { forAuth: true, can: "view_stocks" }
            // },
            {
                path: "profile",
                component: Profile,
                meta: { forAuth: true }
            },
            {
                path: "users",
                meta: { forAuth: true },
                component: blankComponent,
                children: [
                    {
                        path: "/",
                        component: users,
                        meta: { can: "all_users", forAuth: true }
                    },
                    {
                        path: "new",
                        component: newUser,
                        meta: { can: "add_users", forAuth: true }
                    },
                    {
                        path: "edit/:id",
                        component: newUser,
                        meta: { can: "edit_users", forAuth: true }
                    },
                    {
                        path: ":id",
                        component: userView,
                        meta: { can: "view_users", forAuth: true }
                    }
                ]
            },

            {
                path: "roles",
                component: roles,
                meta: { can: "all_roles", forAuth: true }
            },
            {
                path: "/currencies",
                component: currencies,
                meta: { forAuth: true, can: "all_currencies" }
            },
            {
                path: "/backups",
                component: backups,
                meta: { forAuth: true, can: "all_backups" }
            }
        ]
    },
    {
        path: "/auth",
        component: AuthBase,
        meta: { forVisitors: true },
        children: [
            {
                path: "",
                redirect: "login"
            },
            {
                path: "login",
                component: Login
            },
            {
                path: "password-reset",
                component: PasswordReset
            }
        ]
    },
    {
        path: "/print",
        component: PrintLayout,
        children: [
            {
                path: "/",
                component: PrintTable,
                meta: { forAuth: true }
            },
            {
                path: "individuals/:id",
                component: printIndividualCIF,
                meta: { forAuth: true, can: "view_individuals" }
            },
            {
                path: "corporates/:id",
                meta: { forAuth: true, can: "view_corporates" },
                component: printCorporateCIF
            },
            {
                path: "bill",
                component: PrintBill,
                meta: { forAuth: true }
            },
            {
                meta: { forAuth: true },
                component: printDashboard,
                path: "daily-transactions"
            }
        ]
    },
    {
        path: "/404",
        component: P404
    },
    {
        path: "/401",
        component: P401
    },
    {
        path: "*",
        component: P404
    }
];
